export default __webpack_public_path__ + "static/media/right-bolts.ffadcd79.svg";